export * from './text-post';
